














































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";

import RentalBookingJson from "../../shared/RentalBookingJson";
import CustomerJson from "../../shared/CustomerJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";

import SettingsJson from "../../shared/SettingsJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import RentalBookingDetails from "./RentalBookingDetails.vue";
import RentalBookingDetailsAdd from "./RentalBookingDetailsAdd.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalOverview",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    RentalBookingDetails,
    RentalBookingDetailsAdd,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      GeneralInfos: GeneralInfos,
      showDetails: false,
      showDetailsAdd: false as boolean,
      detailsMode: "read",
      bookings: null as RentalBookingJson[] | null,
      bookingsMoreAvailable: false as boolean | null,
      bookingsCurrent: null as RentalBookingJson[] | null,
      bookingsCurrentMoreAvailable: false as boolean | null,
      filterPeriodBookingsCurrent: "today" as "today" | "4weeks",
      selectedBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: RentalBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedBookingId = item.ID;
      } else {
        this.selectedBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadBookings();
      this.loadBookingsCurrent();
    },

    async loadBookings(loadMore: null = null) {
      let states = [RentalBookingStatus.requested, RentalBookingStatus.cancellationPending];
      let rentalItemId = null;
      let afterDate = null;
      let beforeDate = null;
      let skipAmount = null as number | null;

      //load more
      if (loadMore && this.bookings != null) {
        this.bookingsMoreAvailable = null;
        skipAmount = this.bookings.length;
      } else {
        this.bookings = null;
      }

      //final load bookings
      if (this.restClient != null) {
        try {
          let rentals = await this.restClient.getRentalBookings(
            states,
            rentalItemId,
            afterDate,
            beforeDate,
            null,
            skipAmount
          );

          if (loadMore && this.bookings != null) {
            this.bookings = this.bookings.concat(rentals.rentalBookings);
          } else {
            this.bookings = rentals.rentalBookings;
          }

          this.bookingsMoreAvailable = rentals.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBookingsCurrent(loadMore: null = null) {
      let states = [RentalBookingStatus.confirmed, RentalBookingStatus.rentalCollected];
      let rentalItemId = null;
      let afterDate = new Date();
      afterDate.setHours(0, 0, 0, 0);
      let beforeDate = new Date();
      beforeDate.setHours(24, 0, 0, 0);
      let skipAmount = null as number | null;

      //change filter period to 4 weeks
      if (this.filterPeriodBookingsCurrent == "4weeks") {
        let now = new Date();
        beforeDate.setDate(now.getDate() + 4 * 7);
      }

      //load more
      if (loadMore && this.bookingsCurrent != null) {
        this.bookingsCurrentMoreAvailable = null;
        skipAmount = this.bookingsCurrent.length;
      } else {
        this.bookingsCurrent = null;
      }

      //final load bookings
      if (this.restClient != null) {
        try {
          let rentals = await this.restClient.getRentalBookings(
            states,
            rentalItemId,
            afterDate,
            beforeDate,
            null,
            skipAmount
          );

          if (loadMore && this.bookingsCurrent != null) {
            this.bookingsCurrent = this.bookingsCurrent.concat(rentals.rentalBookings);
          } else {
            this.bookingsCurrent = rentals.rentalBookings;
          }

          this.bookingsCurrentMoreAvailable = rentals.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadBookings();
      this.loadBookingsCurrent();
    },

    getDetailedRentalStateString(item: RentalBookingJson) {
      const today = DateFormatter.formatISODate(new Date());

      if (item.state == RentalBookingStatus.confirmed && item.beginDate == today) {
        return "Abholung";
      } else if (item.state == RentalBookingStatus.confirmed && today != item.beginDate) {
        return "Noch nicht abgeholt";
      } else if (item.state == RentalBookingStatus.rentalCollected && today != item.endDate) {
        return "Verliehen";
      } else if (item.state == RentalBookingStatus.rentalCollected && item.endDate == today) {
        return "Rückgabe";
      }
    },

    getPickupReturnTimeString(item: RentalBookingJson) {
      if(item.state == RentalBookingStatus.confirmed) {
        if(item.pickupTime) {
          return item.pickupTime.beginTime + " – " + item.pickupTime.endTime
        }
      }

      if(item.state == RentalBookingStatus.rentalCollected) {
        if(item.returnTime) {
          return item.returnTime.beginTime + " – " + item.returnTime.endTime
        }
      }

      return "--"
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    bookingColumns(): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Vorname",
          td: (i) => (i.customer?.guardianFirstName != null ? i.customer?.guardianFirstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.customer?.guardianLastName != null ? i.customer?.guardianLastName : "--"),
        },
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatDateWeekday(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatDateWeekday(new Date(i.endDate)),
        },
        {
          th: "Status",
          td: (i) => vue.RentalBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];
    },

    bookingTodayColumns(): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      let columns = [
        {
          th: "Organisation",
          td: (i) =>
            i.customer?.guardianOrganisation != null && i.customer?.guardianOrganisation != ""
              ? i.customer?.guardianOrganisation
              : "--",
        },
        {
          th: "Vorname",
          td: (i) =>
            i.customer?.guardianFirstName != null && i.customer?.guardianFirstName != ""
              ? i.customer?.guardianFirstName
              : "--",
        },
        {
          th: "Nachname",
          td: (i) =>
            i.customer?.guardianLastName != null && i.customer?.guardianLastName != ""
              ? i.customer?.guardianLastName
              : "--",
        },
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatDateWeekday(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatDateWeekday(new Date(i.endDate)),
        },
        {
          th: "Status",
          td: (i) => vue.getDetailedRentalStateString(i),
        },
        {
          th: "Abhol-/Rückgabezeit",
          td: (i) => vue.getPickupReturnTimeString(i),
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];

      if(!this.settings.rentalRequestPickupAndReturnTime) {
        columns = columns.filter(i => i.th != "Abhol-/Rückgabezeit")
      }

      return columns
    },
  },
});
